import React from 'react';
import { setDateFormat } from '../../../../../lib/moment';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import Select from '../../../../../components/input/Select';
import Button from '../../../../../components/Button';
import Anchor from '../../../../../components/link/Anchor';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { BRAND_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  ACCOUNT_SELLER_STATUS_SELECT_LIST,
  ACCOUNT_SELLER_STATUS_TEXT,
} from '../../../../../constants/service/app/accountSellerConstants';
import {
  addAllItemToSelectList,
  reDirectPage,
  setBusinessNumberFormat,
  setClearDash,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setPhoneFormat,
} from '../../../../../lib/common';

/**
 *  디비에 등록된 모든 브랜드를 조회하는 테이블
 */
const columns = (data) => {
  const { list, filterOption, onFilter, currentTierList, getBrandTagColumnTagList } = data;

  return [
    {
      accessor: 'storeId',
      Header: '상세보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="상세보기"
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(BRAND_DETAIL_URL_PATH, row.value),
            })
          }
        />
      ),
    },
    {
      accessor: 'url',
      Header: '대표이미지',
      fixed: 'left',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      sortable: true,
      fixed: 'left',
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드 명',
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'storeName'),
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => ACCOUNT_SELLER_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={ACCOUNT_SELLER_STATUS_SELECT_LIST}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      Header: '태그',
      fixed: 'left',
      Cell: (row) =>
        row.original.isTagExists ? (
          <Anchor
            text="태그 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getBrandTagColumnTagList({
                storeId: row.original.storeId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'confirmDate',
      Header: '입점일자',
      fixed: 'left',
      sortable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      accessor: 'tier',
      Header: '티어',
      fixed: 'left',
      filterable: true,
      sortable: true,
      Cell: (row) => setDash(row.value),
      Filter: () => (
        <Select
          list={addAllItemToSelectList(currentTierList)}
          onChange={(tier) => onFilter({ tier })}
          defaultValue={filterOption.tier}
          value={filterOption.tier}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'no',
      Header: '순서',
      fixed: 'left',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'companyName',
      Header: '상호/법인명 ',
      width: 130,
    },
    {
      accessor: 'asPhone',
      Header: 'AS 전화번호',
      filterable: true,
      width: 130,
      Cell: (row) => setPhoneFormat(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.asPhone}
          onFilter={(asPhone) =>
            onFilter({
              asPhone: setClearDash(asPhone),
            })
          }
        />
      ),
    },
    {
      accessor: 'ceoName',
      Header: '대표자명 ',
      width: 130,
    },
    {
      accessor: 'businessLicenseNumber',
      Header: '사업자 등록번호',
      filterable: true,
      width: 130,
      Cell: (row) => setBusinessNumberFormat(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.businessLicenseNumber}
          onFilter={(businessLicenseNumber) => onFilter({ businessLicenseNumber })}
        />
      ),
    },
    {
      accessor: 'balanceEmail',
      Header: '전자세금계산서 이메일',
      width: 200,
    },
  ];
};

export default columns;
